<template>
  <div class="dangerous">
    <NavBar :title="'航空违禁品'" />
    <div class="box">
      <img
        src="../../assets/images/rules/dangerous.png"
        style="object-fit: contain"
        @click="viewImage"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import NavBar from '@/components/NavBar.vue'
import { showImagePreview } from 'vant'
import dangerous from '@/assets/images/rules/dangerous.png'
const viewImage = () => {
  showImagePreview([dangerous])
}
</script>

<style scoped lang="less">
.dangerous {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  .box {
    overflow-y: auto;
    flex: 1;
    > img {
      width: 100%;
      padding: 20px 12px;
    }
  }
}
</style>
